import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BusinessList from './BusinessList';
import BusinessDetail from './BusinessDetail';

const Business: React.FC = () => {
  return (
    <Routes>
      <Route index element={<BusinessList />} />
      <Route path=":id" element={<BusinessDetail />} />
    </Routes>
  );
};

export default Business;